export default {"src":"/_next/static/media/arrow.d52b499b.svg","height":73,"width":90,"blurWidth":0,"blurHeight":0};